"use client";

import { FC } from "react";
import ClassicDivider from "./Divider";

/**
 * GROWTH:CODE 共通セクション見出し
 *
 * 仕様: docs/spec/design_spec.md §3.2 (Card Section Label) / §5.2
 *   - 上下に ClassicDivider
 *   - 中央に 和文ミンチョ 28px + (任意で) 英文セリフ 14px
 *
 * cards 画面の SectionCard 内テキスト構造を共通化したもの。
 */
interface SectionHeadingProps {
  /** 和文ラベル (例: 今日のポイント / メンバー / プロフィール) */
  jp: string;
  /** 英文ラベル (例: TODAY / MEMBERS / PROFILE)。省略時は表示しない */
  en?: string;
  /** 見出しサイズ。'lg' = 28px / 14px (仕様), 'sm' = 18px / 11px (内部見出し用) */
  size?: "lg" | "sm";
  /** 装飾線の最大幅 (px or %) */
  dividerMaxWidth?: number | string;
}

const SectionHeading: FC<SectionHeadingProps> = ({
  jp,
  en,
  size = "lg",
  dividerMaxWidth = 240,
}) => {
  const jpSize = size === "lg" ? 28 : 18;
  const enSize = size === "lg" ? 14 : 11;
  const gap = size === "lg" ? 12 : 8;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap,
        width: "100%",
      }}
    >
      <ClassicDivider maxWidth={dividerMaxWidth} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-mincho)",
            fontSize: jpSize,
            fontWeight: 400,
            color: "var(--color-text-primary, #3a3a3a)",
            letterSpacing: "0.08em",
            lineHeight: 1.2,
          }}
        >
          {jp}
        </span>
        {en && (
          <span
            style={{
              fontFamily: "var(--font-serif)",
              fontSize: enSize,
              fontWeight: 400,
              color: "var(--color-text-secondary, #8e8e8e)",
              letterSpacing: "0.16em",
              lineHeight: 1.2,
            }}
          >
            {en}
          </span>
        )}
      </div>
      <ClassicDivider maxWidth={dividerMaxWidth} />
    </div>
  );
};

export default SectionHeading;
